module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-sm"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Send Invoice")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [(_vm.getSelectedInvoice.invoiceClientEmail) ? _c('div', {
    staticClass: "d-flex flex-column p-4 fs-large"
  }, [_c('span', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.sendInvoiceMessage))]), _vm._v(" "), _c('input', {
    staticClass: "bold input-heigth",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.getSelectedInvoice.invoiceClientEmail
    }
  })]) : _c('div', {
    staticClass: "p-4"
  }, [_c('span', {
    staticClass: "fs-normal"
  }, [_vm._v("\n                    There is no email associated. Please check the "), _c('strong', [_vm._v(_vm._s(_vm.getSelectedInvoice.targetType === 0 ? 'Customer' : 'Agent'))]), _vm._v(" information.\n                ")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end pr1"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    class: {
      'disabled notAllowed': !_vm.getSelectedInvoice.invoiceClientEmail
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.getSelectedInvoice.invoiceClientEmail
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_c('span', [_vm._v("Send Email")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-8df058e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df058e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/SendInvoice.vue
// module id = 2255
// module chunks = 0